<section id="partner-toolbar">
  <div class="flex vcenter">
    <button
      payee-button
      (click)="createPartner()"
    >
      Partner Hozzáadása
    </button>
  </div>
</section>
<section id="partner-table-section">
  <table
    mat-table
    matSort
    class="mat-elevation-z1"
    id="partner-table"
    [dataSource]="dataSource"
  >
    <ng-container matColumnDef="integration">
      <th
        *matHeaderCellDef
        mat-header-cell
        mat-sort-header
      >
        Partner ID
      </th>
      <td
        *matCellDef="let element"
        mat-cell
      >
        {{ element.integration }}
      </td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th
        *matHeaderCellDef
        mat-header-cell
        mat-sort-header
      >
        Partner Neve
      </th>
      <td
        *matCellDef="let element"
        mat-cell
      >
        {{ element.name }}
      </td>
    </ng-container>

    <ng-container matColumnDef="api_key">
      <th
        *matHeaderCellDef
        mat-header-cell
        mat-sort-header
      >
        Partner Token
      </th>
      <td
        *matCellDef="let element"
        mat-cell
      >
        {{ element.api_key }}
      </td>
    </ng-container>

    <ng-container matColumnDef="origin">
      <th
        *matHeaderCellDef
        mat-header-cell
        mat-sort-header
      >
        User Source
      </th>
      <td
        *matCellDef="let element"
        mat-cell
      >
        {{ element.origin }}
      </td>
    </ng-container>

    <ng-container matColumnDef="created_at">
      <th
        *matHeaderCellDef
        mat-header-cell
        mat-sort-header
      >
        Partner Létrejötte
      </th>
      <td
        *matCellDef="let element"
        mat-cell
      >
        {{ element.created_at | date: "yyyy.MM.dd." }}
      </td>
    </ng-container>

    <ng-container matColumnDef="edit">
      <th
        *matHeaderCellDef
        mat-header-cell
      ></th>
      <td
        *matCellDef="let element"
        mat-cell
      >
        <button
          payee-icon-button
          color="white"
          (click)="editPartner(element)"
        >
          <payee-icon name="edit-grey"></payee-icon>
        </button>
      </td>
    </ng-container>

    <tr
      *matHeaderRowDef="displayedColumns"
      mat-header-row
    ></tr>
    <tr
      *matRowDef="let element; columns: displayedColumns"
      mat-row
      class="element-row"
    ></tr>
  </table>
</section>
